function getImages() {
  const importAll = (r) => r.keys().map(r);
  const images = importAll(
    require.context("../assets/images/gallery/", true, /\.(png|jpe?g|JPG)$/)
  );
  return images.sort(() => 0.5 - Math.random());
}

export default getImages;
